import { render, staticRenderFns } from "./ProductSingleRelatedTaxonomy.vue?vue&type=template&id=b7ba2e40&"
import script from "./ProductSingleRelatedTaxonomy.vue?vue&type=script&lang=js&"
export * from "./ProductSingleRelatedTaxonomy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports